function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgProline(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("g", {
    fill: "#040000"
  }, React.createElement("path", {
    d: "M20.118 85.594c-6.15 0-11.154-5.004-11.154-11.154s5.004-11.154 11.154-11.154S31.272 68.29 31.272 74.44s-5.004 11.154-11.154 11.154zm0-14.376c-1.777 0-3.222 1.446-3.222 3.222s1.446 3.222 3.222 3.222 3.222-1.446 3.222-3.222-1.445-3.222-3.222-3.222zM77.831 85.453c-6.15 0-11.154-5.004-11.154-11.154s5.003-11.154 11.154-11.154c6.15 0 11.154 5.004 11.154 11.154s-5.003 11.154-11.154 11.154zm0-14.377c-1.777 0-3.222 1.446-3.222 3.222s1.445 3.222 3.222 3.222 3.222-1.446 3.222-3.222-1.445-3.222-3.222-3.222z"
  }), React.createElement("path", {
    d: "M58.209 77.827H39.424a3.966 3.966 0 01-3.966-3.966V18.338H24.456V65.93a3.966 3.966 0 01-7.932 0V14.372a3.966 3.966 0 013.966-3.966h18.934a3.966 3.966 0 013.966 3.966v55.524h10.853V14.372a3.966 3.966 0 013.966-3.966h19.829a3.966 3.966 0 013.966 3.966v50.195a3.966 3.966 0 01-7.932 0V18.338H62.175v55.524a3.965 3.965 0 01-3.966 3.965z"
  })));
}

SvgProline.clsName = 'icon-www__proline';
SvgProline.remarkName = 'unknown';
export default SvgProline;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Proline.js
// module id = 2405
// module chunks = 17 18